/**
 * 发货单枚举定义
 * @module types/shipment/enums
 * @description 发货单相关的枚举类型定义
 * @last-updated 2025-12-26
 */

/**
 * 发货单状态枚举
 * @对应后端 Shipment::STATUS_*
 */
export enum ShipmentStatus {
  /** 待发货 */
  PENDING = 1,
  /** 已发货 */
  SHIPPED = 2,
  /** 已签收 */
  RECEIVED = 3,
  /** 已取消 */
  CANCELLED = 4,
}

/**
 * 发货方式枚举
 * @对应后端 Shipment::METHOD_*
 */
export enum ShippingMethod {
  /** 快递 */
  EXPRESS = 'EXPRESS',
  /** 物流 */
  LOGISTICS = 'LOGISTICS',
  /** 自提 */
  SELF_PICKUP = 'SELF_PICKUP',
}
